import React, { useEffect } from 'react';
import { ListItem, ListItemText, ListItemAvatar, Avatar } from '@material-ui/core';
import { EggHunter } from 'redux/models/eggHunter';
import moment from 'moment';
import { getProfilePic } from 'api/requests';
import { addDefaultProfileImgSrc } from 'helpers/reactHelper';
import './EggHunterItem.scss';

interface EggHunterItemProps {
	hunter: EggHunter;
	itemNum: number;
}

const EggHunterItem: React.FC<EggHunterItemProps> = (props: EggHunterItemProps) => {
	const { hunter, itemNum } = props;
	const [authorPic, setAuthorPic] = React.useState<string | undefined>();

	const getProfilePicForAuthor = async (authorEmail: string) => {
		const pic = await getProfilePic(authorEmail);
		setAuthorPic(pic);
	};

	useEffect(() => {
		if (hunter) {
			getProfilePicForAuthor(hunter.userEmail);
		}
	}, [hunter]);

	return (
		<ListItem key={hunter.eggHunterId}>
			<div className='egg-hunter-item__num'>{`${itemNum}.`}</div>
			<ListItemAvatar>
				<Avatar alt={hunter.userName} src={authorPic} onError={e => addDefaultProfileImgSrc(e)} />
			</ListItemAvatar>
			<ListItemText primary={hunter.userName} secondary={moment(hunter.completionDate).format('MMM DD, YYYY @ h:mm A')} />
		</ListItem>
	);
};

export default EggHunterItem;
